import styled from "@emotion/styled";
import { ExTabs, useResizeObserver, useToastMessage } from "@energyx-dev/energyx-ui";
import { CorporationPassword } from "components/password/CorporationPassword";
import { NormalPassword } from "components/password/NormalPassword";
import useTranslation from "hooks/useTranslation";

import { useState } from "react";

export const Password = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const isEnglishPage = useTranslation();
  const device = useResizeObserver();
  const { toastContainer } = useToastMessage();

  return (
    <PasswordContainer>
      {device && toastContainer(device)}
      <article>
        <Title>{isEnglishPage ? "Find Password" : "비밀번호 찾기"}</Title>
        <Contents>
          <ExTabs
            tabs={[
              {
                name: isEnglishPage ? "Individual" : "일반회원",
                isExistNew: false,
              },
              {
                name: isEnglishPage ? "Business" : "법인회원",
                isExistNew: false,
              },
            ]}
            variant="underline"
            size="small"
            contentsIndex={tabIndex}
            setContentsIndex={setTabIndex}
            gap="0px"
          />
          {tabIndex === 0 ? <NormalPassword /> : <CorporationPassword />}
        </Contents>
      </article>
    </PasswordContainer>
  );
};

const PasswordContainer = styled.section`
  padding: 80px 0;
  margin: 0 auto;
  width: 100%;
  max-width: 448px;
  article {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  ${({ theme }) => theme.breakpoints.down("DESKTOP")} {
    article {
      width: 100%;
      padding: 24px 16px 40px 16px;
      gap: 24px;
    }
  }
`;

const Title = styled.h2`
  ${({ theme }) => theme.font.H2};
  text-align: center;

  ${({ theme }) => theme.breakpoints.down("DESKTOP")} {
    ${({ theme }) => theme.font.Body3_h}
  }
`;

const Contents = styled.div`
  cursor: pointer;
  > div:first-of-type {
    border-bottom: 1px solid ${({ theme }) => theme.color.mono[10]};
    margin-bottom: 24px;
  }

  ${({ theme }) => theme.breakpoints.down("TABLET")} {
    gap: 16px;
  }
`;
